import React from "react";
import AssignedMediaGridTest from "./AssignedMediaGridTest";

export default function AssignedMediaGridTestPage() {
  return (
    <div style={{ padding: 40 }}>
      <h2>AssignedMediaGrid Test Page</h2>
      <AssignedMediaGridTest />
    </div>
  );
}
